import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicContainerBase } from '@lsqlabs/dr-application-shared';

@Component({
    selector: 'dynamic-container-admin',
    styleUrls: ['./dynamic-container-admin.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dynamic-container-admin.component.html'
})
export class DynamicContainerAdmin extends DynamicContainerBase {
    @Input() reviewMode: Boolean = true;
    @Input() adminMode: Boolean = true;
}
